import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
var ModalHeader = React__default.forwardRef(function (_a, ref) {
  var _b = _a.hasBorder,
    hasBorder = _b === void 0 ? false : _b,
    rest = __rest(_a, ["hasBorder"]);
  return React__default.createElement(Box, __assign({
    width: "100%",
    minHeight: ["56px", "64px"],
    position: "relative",
    borderBottom: hasBorder ? "1px solid" : undefined,
    borderBottomColor: "grey.5",
    display: "flex",
    alignItems: "center"
  }, rest, {
    ref: ref
  }));
});
export { ModalHeader };